import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectStatus, Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-vessel-information-list',
    templateUrl: './vessel-information-list.component.html',
    styleUrls: ['./vessel-information-list.component.css'],
    standalone: false,
})
export class VesselInformationListComponent {
    @Input() vessel: Vessel;
    @Input() shipyardName: string;
    @Input() vesselEditors: { name; image; userOid }[];

    constructor(private router: Router) {}

    openVesselPage(vessel: Vessel) {
        this.router.navigateByUrl(`home/${this.vessel.shipyardId}/${vessel.id}`);
    }

    getVesselMimics(vessel) {
        return vessel.Mimics?.length || 0;
    }

    getIcon(vessel: Vessel): string {
        if (!vessel) return;
        if (vessel.projectStatus === ProjectStatus.PendingApproval) return 'pending-approval';
        else if (vessel.projectStatus === ProjectStatus.Approved) return 'spaceship';
        else if (vessel.locked) return 'lock-profile';
    }
}
